import { Injectable } from '@angular/core';
import {SharedService} from "../../shared/shared.service";
import {TenantService} from "../../tenant/tenant.service";
import {first} from "rxjs/operators";
import {CategoryService} from "../category/category.service";
import {ServiceDataService} from "./service.data.service";
import {SubcontractorService} from "../subcontractor/subcontractor.service";

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  public ratios: any;
  public staffs: any;
  public categories: any;
  public scopes: any;
  public serviceTypes: any;
  public subcontractors: any;

  constructor(
    public sharedService: SharedService,
    public tenantService: TenantService,
    public categoryService: CategoryService,
    public serviceDataService: ServiceDataService,
    public subcontractorService: SubcontractorService
  ) {}

  getTaxAndDiscClasses = () => {
    this.sharedService.getTaxAndDiscClasses()
      .pipe(first())
      .subscribe(
        data => {
          this.ratios = data;
        });
  }

  getStaffs = () => {
    this.tenantService.getStaffs()
      .pipe(first())
      .subscribe(
        data => {
          this.staffs = data;
        });
  }

  getCategories = () => {
    this.categoryService.getServiceCategories()
      .pipe(first())
      .subscribe(
        data => {
          this.categories = data;
          console.log('this.categories', this.categories);
        });
  }
  getScopes = () => {
    this.sharedService.getScopes()
      .pipe(first())
      .subscribe(
        data => {
          this.scopes = data.data;
        });
  }
  getServiceType = () => {
    return this.serviceDataService.getTypes()
      .pipe(first())
      .subscribe(
        data => {

          this.serviceTypes = data.data;
          console.log("Service Type",this.serviceTypes);

        });
  }

  getSubcontractorType = () => {
    return this.subcontractors = [];
  }

  getSubcontractors = () => {
      this.subcontractorService.getSubcontractors({per_page:100})
        .pipe(first())
        .subscribe(data => {
          this.subcontractors = data.data;
        });
  }

  getSubcontractorsList = (id:any) => {
    this.subcontractorService.getSubcontractorslist({per_page:100, tenant_id: id})
      .pipe(first())
      .subscribe(data => {
        this.subcontractors = data.data;
      });
}
}
